import createIcon from '../../createIcon';

/**
 * @component @name SportsGymnastics
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA1QzQgMy45IDQuOSAzIDYgM0M3LjEgMyA4IDMuOSA4IDVDOCA2LjEgNy4xIDcgNiA3QzQuOSA3IDQgNi4xIDQgNVpNMSA4SDdMMTQgM0wxNS4zMSA0LjUyTDExLjE0IDcuNUgxNEwyMS44IDNMMjMgNC40TDE0LjUgMTFMMTQgMjFIMTJMMTEuNSAxMUw4IDEwSDFWOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsGymnastics = createIcon('SportsGymnastics', [
  [
    'path',
    {
      d: 'M4 5C4 3.9 4.9 3 6 3C7.1 3 8 3.9 8 5C8 6.1 7.1 7 6 7C4.9 7 4 6.1 4 5ZM1 8H7L14 3L15.31 4.52L11.14 7.5H14L21.8 3L23 4.4L14.5 11L14 21H12L11.5 11L8 10H1V8Z',
      key: 'ppm10x',
    },
  ],
]);

export default SportsGymnastics;
